import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.COMPANY_DEFAULT_VALUE_ADD_NEW_THIRD_PARTY_PAYMENT_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
